import FlashLib from "flashlib";
import Animation from "Engine/base/animation/Animation";

export default class LogoContainer extends FlashLib.MovieClip {
    constructor(data, displayData) {
        super(data, displayData);

        this.animation = null;

        this.init();
    }

    init() {
        this.removeChildren();
        this.animation = new Animation('logo_spine');
        this.animation.play(true, 'animation');
        this.addChild(this.animation);
    }
}